import React from 'react';

const BlackJackV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.73907 2.79302C5.8494 1.53187 6.9612 0.598965 8.22234 0.7093L16.526 1.43577C17.7871 1.54611 18.72 2.65791 18.6097 3.91905L17.5926 15.5441C17.4823 16.8053 16.3705 17.7382 15.1093 17.6278L14.8611 17.6061C14.4856 18.1379 13.8872 18.507 13.1878 18.5682L4.8842 19.2947C3.62306 19.405 2.51126 18.4721 2.40092 17.211L1.38386 5.58589C1.27353 4.32474 2.20644 3.21295 3.46758 3.10261L5.72929 2.90474L5.73907 2.79302ZM5.61864 4.16949L3.57655 4.34815C3.0033 4.39831 2.57925 4.90367 2.6294 5.47691L3.64647 17.102C3.69662 17.6752 4.20198 18.0993 4.77523 18.0491L12.35 17.3864L6.80572 16.9014C5.54458 16.791 4.61167 15.6792 4.722 14.4181L5.61864 4.16949ZM8.11337 1.95484C7.54013 1.90469 7.03476 2.32874 6.98461 2.90199L5.96755 14.5271C5.9174 15.1003 6.34145 15.6057 6.91469 15.6558L15.2183 16.3823C15.7916 16.4325 16.2969 16.0084 16.3471 15.4352L17.3641 3.81008C17.4143 3.23683 16.9902 2.73147 16.417 2.68132L8.11337 1.95484ZM9.84132 10.9296C8.88602 10.8123 8.19774 10.022 8.30485 9.14958C8.46626 7.83503 10.0587 6.48097 12.0678 5.8579C13.927 6.95518 15.0766 8.7019 14.9223 9.95852C14.8151 10.8309 13.9548 11.4347 12.9987 11.3173C12.4331 11.2479 12.1818 10.9561 11.9141 10.5289C11.9143 10.6154 11.9144 10.6615 11.9165 10.7075C11.919 10.7598 11.9243 10.812 11.9354 10.9236C11.9564 11.1333 11.9983 11.5527 12.0825 12.5764L10.4283 12.3733C10.7576 11.4003 10.8994 11.0034 10.9702 10.8049C11.008 10.6991 11.0257 10.6497 11.0408 10.5996C11.0541 10.5556 11.0656 10.511 11.087 10.4273C10.7248 10.7765 10.4102 10.9995 9.84132 10.9296Z",
      fill: "#FFFFFF"
    }
  )
);

export { BlackJackV2 };
//# sourceMappingURL=BlackJackV2.js.map
